import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Flex } from "theme-ui";
export const FormStack = ({ children }) => {
    return (_jsx(Flex, { sx: {
            flexDirection: "column",
            "& .form-input + .form-input": {
                mt: 16
            },
            "& .form-input + button": {
                mt: 40
            }
        }, children: children }));
};
//# sourceMappingURL=FormStack.js.map